import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_FULL = "https://customer-assets.emergentagent.com/job_seal-jobs-app/artifacts/pw5aw3sm_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2012_30_23%20PM.png";
export const LOGO_SHIELD = "https://customer-assets.emergentagent.com/job_seal-jobs-app/artifacts/pw5aw3sm_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2012_30_23%20PM.png";
export const LOGIN_BG = "https://images.unsplash.com/photo-1552072232-059f1a5d76c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbmF2eSUyMGJsdWUlMjBhYnN0cmFjdCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODI4ODY1ODl8MA&ixlib=rb-4.1.0&q=85";

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ts_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function fileUrl(path) {
  const token = localStorage.getItem("ts_token");
  return `${API}/files/${path}?auth=${token}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}
